import { render, staticRenderFns } from "./product-topnew.vue?vue&type=template&id=c3fd341a&"
import script from "./product-topnew.vue?vue&type=script&lang=js&"
export * from "./product-topnew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports